import axios from "axios";
import Cookies from "js-cookie";

class UploadsApi {
  getAuthHeaders(contentType = "application/json") {
    const token = Cookies.get("jwt");
    return {
      headers: {
        "Content-Type": contentType,
        Authorization: `Bearer ${token}`,
      },
    };
  }

  async uploadImage(data) {
    try {
      const url = `${process.env.REACT_APP_API_BASE_URL}/uploads/upload-image`;
      return await axios.post(url, data, this.getAuthHeaders());
    } catch (err) {
      throw err;
    }
  }

  async uploadFile(formData) {
    try {
      const url = `${process.env.REACT_APP_API_BASE_URL}/uploads/upload-file`; 
      return await axios.post(url, formData, this.getAuthHeaders("multipart/form-data"));
    } catch (err) {
      throw err;
    }
  }
  
}

export default new UploadsApi();
